import React from "react";

export default function InfoProductBasketCard() {
  return (
    <div style={{ marginTop: "30px" }}>
      <h3>Informatie Over de Nestjes</h3>
      {"Bedankt voor het bestellen van een Suusje Pluusje babynestje."}
      <p></p>
      {`Suusje Pluusje nestjes zijn handgemaakt van duurzaam, zacht en veilig katoen. Het liggedeelte is 100% katoen en zorgt voor een warm en toch ademend bedje voor je kindje. De buitenrand is gevuld met zacht ademend katoen aan het oppervlak en fiberfill daar onder.`}
      <p></p>
      {
        "Je nestje is verstelbaar in grootte door het aan te trekken koord. Ook kan je het nestje blijven gebruiken als je kindje groter wordt, door het koortje helemaal los te maken en de beentjes uit laten steken. Let er wel op dat je kindje niet gaat spelen met het koord of de koortstopper!"
      }
      <p></p>
      {`Je nestje is al gestoomd en kan direct veilig worden gebruikt door je kindje. Je nestje kan gewassen worden in de machine, op max 40 graden, met weinig wasmiddel (of extra spoelen).  De nestjes zijn niet geschikt voor de droger (de vulling in de buitenrand droogt zo ongelijk en kan niet meer mooi worden verdeeld). Soms is het nodig om de vulling in de buitenrand even opnieuw te schudden en verdelen, dit is niet nodig wanneer je een ‘voorzichtig centrifugeren’ programma heeft op de wasmachine. Het liggedeelte van het nestje kan ook op hoge temperatuur gestreken worden.`}
      <p></p>
      {`Heb je nog vragen of opmerkingen? Kijk voor meer informatie op `}
      <a
        target="_blank"
        href="http://www.suusjepluusje.nl"
        rel="noopener noreferrer"
      >
        www.suusjepluusje.nl
      </a>
      {` of stuur me een email via `}{" "}
      <a
        target="_blank"
        href="mailto:susanneou@gmail.com"
        rel="noopener noreferrer"
      >
        susanneou@gmail.com
      </a>
      {`.`}
    </div>
  );
}
